import { useState } from 'react'
import { KTSVG } from '../../../../../../../_template/helpers'
import DriverAreaForm from '../../../../../../components/driverAreaForm'

const DriverAreaListToolbar = () => {
  // const locale: string = useLang()
  const [show, setShow] = useState(false)
  // const [submitting, setSubmitting] = useState(false)
  const handleShow = () => setShow(true)
  const handleClose = () => setShow(false)


  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      {/* <Export dataType='users' /> */}

      {/* begin::Add user */}
      <button onClick={handleShow} type='button' className='btn btn-design btn-icon'>
        <KTSVG
          path='/media/icons/duotune/arrows/arr075.svg'
          className='svg-icon-2 svg-icon-light'
        />
      </button>
      {<DriverAreaForm handleClose={handleClose} show={show} />}
    </div>
  )
}

export { DriverAreaListToolbar }
